import { not } from './functionChaining'
import { wrapInCurlyBrackets } from './variable'
import { STORAGE_PERMITTED_SYMBOLS } from '../features/storages/constants'

export const hasNonWhitespace = (text: string) => /\S/.test(text)

export const isAllWhitespaces = not(hasNonWhitespace)

export const VARIABLE_INTERPOLATED_IN_CURLY_BRACKETS_REGEX = new RegExp(
  `{([0-9a-zA-Z](?:[0-9a-zA-Z${STORAGE_PERMITTED_SYMBOLS}]*?[0-9a-zA-Z])?)}`,
  'g'
)

export function isValidVariableName(variableName: string) {
  const variableNameInCurlyBrackets = wrapInCurlyBrackets(variableName)

  const matches = variableNameInCurlyBrackets.match(VARIABLE_INTERPOLATED_IN_CURLY_BRACKETS_REGEX)

  return matches && matches.length === 1 && matches[0] === variableNameInCurlyBrackets
}

export const removeGlobal = (regExp: RegExp): RegExp => {
  return new RegExp(regExp, regExp.flags.replace('g', ''))
}

export const isValidDialogId = (text?: string | null): boolean => {
  if (!text) {
    return false
  }

  if (text.startsWith('-') || text.endsWith('-')) {
    return false
  }

  return /^[a-zA-Z0-9-]*$/.test(text)
}
